import { Button, Pagination, Group, Menu } from '@mantine/core';

import { PAGE_LIMIT_OPTIONS, URL_PARAMS } from 'constants/urlFiltering';

import { ChevronDownIconXs } from '@chownow/pantry/icons';

export type HandleChangeFilters = (param: string, filter: number | string) => void;

interface PaginationControlsProps {
  handleChangeFilters: HandleChangeFilters;
  page?: number;
  pageSize?: number;
  totalPages?: number;
  mr?: string | number;
}

export default function PaginationControls({
  handleChangeFilters,
  page,
  pageSize,
  totalPages,
  mr = 'md',
}: PaginationControlsProps) {
  if (pageSize === 10 && totalPages === 1) {
    return null;
  }

  return (
    <Group justify="space-between" pt="md" mr={mr}>
      <Button.Group>
        <Menu>
          <Menu.Target>
            <Button variant="ghost" size="sm" rightSection={<ChevronDownIconXs />}>
              View {pageSize}
            </Button>
          </Menu.Target>
          <Menu.Dropdown>
            {PAGE_LIMIT_OPTIONS.map(option => (
              <Menu.Item
                key={`page_limit_${option}`}
                onClick={() => handleChangeFilters(URL_PARAMS.PAGE_SIZE, option)}
              >
                View {option}
              </Menu.Item>
            ))}
          </Menu.Dropdown>
        </Menu>
      </Button.Group>
      <Pagination
        total={totalPages || 0}
        value={page}
        onChange={pageNumber => handleChangeFilters(URL_PARAMS.PAGE, pageNumber)}
      />
    </Group>
  );
}
